import AccessDenied from "../../../Pages/Shared/AccessDenied";
import Home from "../../../Pages/Shared/Home/Home";
import { IRoute } from "./IbssRouter";

export default class SharedRoutes
{
    public routes: IRoute[] = [
        {
            isAuthorised: () => true,
            path: "/access-denied",
            component: AccessDenied
        },
        {
            isAuthorised: () => true,
            path: "/",
            component: Home
        },
    ];
}
